import { ReactNode } from 'react';

import SpeedBonusConnectionContext from './context';
import LayoutSwitcher from './LayoutSwitcher';

const SpeedBonusConnection = ({ children }: { children: ReactNode }): JSX.Element => {
    return (
        <SpeedBonusConnectionContext>
            <LayoutSwitcher>
                {children}
            </LayoutSwitcher>
        </SpeedBonusConnectionContext>
    );
};

export default SpeedBonusConnection;
